module.exports = __webpack_public_path__ + "img/google-play-tw.f89b47d9.png";